import createReactComponent from '../createReactComponent';
export default createReactComponent('stairs-up', 'IconStairsUp', [
  ['path', { d: 'M22 6h-5v5h-5v5h-5v5h-5', key: 'svg-0' }],
  ['path', { d: 'M6 10v-7', key: 'svg-1' }],
  ['path', { d: 'M3 6l3 -3l3 3', key: 'svg-2' }],
]);
